"use client"

import { Box, Typography, Button, Paper } from "@mui/material"
import { PointOfSale as PointOfSaleIcon } from "@mui/icons-material"

const VentaMobileFooter = ({ precioTotal, onConfigClick, disabled = false }) => {
  return (
    <Paper
      elevation={8}
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        p: 1.5,
        backgroundColor: "white",
        borderTop: "2px solid #5b5b5f",
        zIndex: 1000,
        boxShadow: "0px -4px 12px rgba(0, 0, 0, 0.15)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 1.5,
        }}
      >
        <Box sx={{ flex: 1 }}>
          <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 0.25, fontSize: "0.7rem" }}>
            Total
          </Typography>
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: "bold",
              color: "rgb(244, 147, 14)",
              fontSize: "1rem",
            }}
          >
            {new Intl.NumberFormat("es-AR", {
              style: "currency",
              currency: "ARS",
            }).format(precioTotal)}
          </Typography>
        </Box>
        <Button
          variant="contained"
          color="primary"
          size="medium"
          onClick={onConfigClick}
          disabled={disabled}
          startIcon={<PointOfSaleIcon fontSize="small" />}
          sx={{
            py: 1,
            px: 2,
            borderRadius: 1.5,
            fontWeight: 600,
            boxShadow: 2,
            backgroundColor: "green",
            color: "white",
            textTransform: "none",
            minWidth: 140,
            fontSize: "0.875rem",
            "&:hover": {
              backgroundColor: "#2e7d32",
            },
            "&:disabled": {
              backgroundColor: "rgba(0, 0, 0, 0.12)",
              color: "rgba(0, 0, 0, 0.26)",
            },
          }}
        >
          Configurar
        </Button>
      </Box>
    </Paper>
  )
}

export default VentaMobileFooter

